import React from 'react'
import { useLocation } from 'react-router-dom'
import ReadOnlyNotice from 'modules/Admin/ReadOnlyNotice'
import { useMediaQuery, useTheme } from '@mui/material'
import BusinessHeader from '../BusinessHeader'

const BusinessPage = ({ children, title, showReadOnlyNotice = true }) => {
  const admin = useLocation().pathname.startsWith('/admin')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  if (admin) return <section>{children}</section>
  return (
    <main
      style={{
        background: '#fcfcfc',
        marginLeft: isMobile ? 0 : 300,
        minHeight: '100vh',
      }}
    >
      <BusinessHeader title={title} />
      {showReadOnlyNotice && <ReadOnlyNotice business />}
      {children}
    </main>
  )
}

export default BusinessPage
